import * as tslib_1 from "tslib";
import * as React from 'react';
import strings from 'owa-strings/owa-common-strings';
import { personaCardBehavior, } from 'owa-persona/lib/components/PersonaCardBehavior';
import { observer } from 'mobx-react';
var styles = require('./ReadOnlyRecipient.scss');
var classNames = require('classnames');
var ReadOnlyRecipient = /** @class */ (function (_super) {
    tslib_1.__extends(ReadOnlyRecipient, _super);
    function ReadOnlyRecipient() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ReadOnlyRecipient.prototype.render = function () {
        var recipientContent;
        if (this.props.onlyShowEmail) {
            recipientContent = this.props.viewState.email.EmailAddress;
        }
        else {
            recipientContent = this.props.renderSelf
                ? strings.recipientSelf
                : this.props.viewState.email.Name;
            if (this.props.viewState.showFullEmail) {
                recipientContent += ' <' + this.props.viewState.email.EmailAddress + '>';
            }
            recipientContent += ';';
        }
        return (React.createElement("div", { className: classNames(styles.recipientContent, this.props.className, this.props.viewState.isGroupOrDl ? styles.groupOrDl : null), onClick: this.props.onPersonaCardBehaviorClick, onMouseEnter: this.props.onPersonaCardBehaviorMouseEnter, onMouseLeave: this.props.onPersonaCardBehaviorMouseLeave },
            ' ',
            recipientContent));
    };
    ReadOnlyRecipient = tslib_1.__decorate([
        personaCardBehavior,
        observer
    ], ReadOnlyRecipient);
    return ReadOnlyRecipient;
}(React.Component));
export default ReadOnlyRecipient;
//# sourceMappingURL=ReadOnlyRecipient.js.map